import type { ReactElement } from 'react'

import { updatePlatformHeader } from '../services/api/auth'
import { setPlatformForLogs } from '../services/datadog'
import { nativeAuthRedirect } from '../utils/nativeAuthRedirect'
import { BaseSignInRoute } from './BaseSignInRoute'

export const SignInAndroidRoute = (): ReactElement => {
  const platform = 'android'

  updatePlatformHeader(platform)
  setPlatformForLogs(platform)

  return BaseSignInRoute(
    (accessToken, authenticationCode, secondaryFactor, redirectTo) =>
      nativeAuthRedirect(accessToken, redirectTo ?? '', authenticationCode, secondaryFactor),
    platform,
  )
}
